import date from 'element-ui/lib/utils/date'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js'

import { WEB_BEHAVIORS } from './constant/behavior'

import { phoneReg } from './formValidate'

export function isCellphone(phone) {
  return phoneReg.test(phone)
}

export const publicKey =
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
  '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='

export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}

export function getCurrentMonthDate() {
  let date = new Date()
  date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01 00:00:00'
  return new Date(date)
}

export function isParent(obj, parentObj) {
  while (obj !== undefined && obj != null && obj.tagName.toUpperCase() !== 'BODY') {
    if (obj === parentObj) {
      return true
    }
    obj = obj.parentNode
  }
  return false
}

export function getEnumText(enumObj, enumCode, code) {
  if (!enumObj || !code || !enumCode || typeof enumObj !== 'object' || !enumObj[enumCode]) return ''
  if (code === enumObj[enumCode].CODE) {
    return enumObj[enumCode].TXT
  } else {
    return ''
  }
}

export function formatTime(time, option) {
  if (typeof time !== 'object') {
    if (('' + time).length === 10) time = parseInt(time) * 1000
  }
  return date.format(Number(time), option)
}

export function getMonthDesc(time) {
  if (!time) {
    return ''
  }
  if (('' + time).length === 10) time = parseInt(time) * 1000
  const date = new Date(time)
  const nowDate = new Date()
  if (date.getFullYear() !== nowDate.getFullYear()) {
    return date.getFullYear() + '年' + (date.getMonth() + 1) + '月'
  } else {
    return date.getMonth() + 1 + '月'
  }
}

export function getDefaultBarOptions() {
  return {
    title: {
      text: ''
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          shadowColor: '#f0fbff',
          color: 'rgba(240, 251, 255, 0.3)'
        }
      },
      formatter(params, data) {
        const axisValue = params[0].axisValue
        const value = params[0].value
        return `${axisValue} ${value} 次`
      }
    },
    legend: {},
    grid: {
      left: '20',
      right: '20',
      top: '20',
      bottom: '20',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      minInterval: 1,
      axisLine: {
        lineStyle: {
          type: 'solid',
          color: '#333',
          opacity: 0.1
        }
      },
      axisLabel: {
        textStyle: {
          color: '#333',
          opacity: 1
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#333',
          opacity: 0.4
        }
      },
      axisTick: {
        lineStyle: {
          color: '#333',
          opacity: 1
        }
      }
    },
    color: ['#38A4F5'],
    yAxis: {
      type: 'category',
      data: [],
      axisLine: {
        lineStyle: {
          type: 'solid',
          // color: '#979797',
          opacity: 0
        }
      },
      axisLabel: {
        textStyle: {
          // color: '#979797',
          opacity: 1
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#979797',
          opacity: 1
        }
      },
      axisTick: {
        lineStyle: {
          color: '#979797',
          opacity: 1
        }
      }
    },
    series: {
      name: '操作次数',
      type: 'bar',
      label: {
        show: true,
        precision: 1,
        position: 'right',
        valueAnimation: true,
        fontFamily: 'monospace'
      },
      barMinHeight: 20,
      data: []
    }
  }
}

export function getWebBehaviorName(obj) {
  if (typeof obj !== 'object' || !obj.name) {
    return ''
  } else {
    if (WEB_BEHAVIORS[obj.behavior]) {
      return WEB_BEHAVIORS[obj.behavior]
    } else {
      return obj.name
    }
  }
}

export function getDefaultPieOptions() {
  return {
    title: {
      show: true,
      text: '组织分布情况',
      textStyle: {
        color: 'rgba(0, 0, 0, .72)',
        fontSize: 14,
        fontFamily: 'Microsoft YaHei',
        fontWeight: '500'
      },
      textAlign: 'left',
      left: '0'
    },
    tooltip: {
      show: true,
      trigger: 'item'
    },
    legend: null,
    series: {
      name: '',
      type: 'pie',
      center: ['40%', '50%'],
      radius: ['60%', '80%'],
      // avoidLabelOverlap: false,
      // silent: true,
      labelLine: {
        show: true,
        length: 15,
        length2: 15,
        smooth: false,
        minTurnAngle: 90,
        maxSurfaceAngle: 90
      },
      label: {
        show: true,
        position: 'center',
        textStyle: {
          fontSize: '14',
          color: '#000000',
          opacity: 0.72,
          lineHeight: '20'
        },
        formatter: function(item) {
          console.log('item', item, item.percent)
          if (item.name === '分散型组织') {
            return `${item.name} \n{a| ${item.value}} 个\n占比 ${item.percent}%`
          } else {
            return ''
          }
        },
        rich: {
          a: {
            color: '#38A4F5',
            fontSize: '16',
            fontWeight: 'bold'
          }
        }
      },
      data: []
    }
  }
}
